import React, { useEffect } from "react";
import "./new.css";
import { Link } from "react-router-dom";
import NavBar from "../components/Nav";
import Footer from "../components/footer";
import ScrollTop from "../components/Scrolltop";
import Whatsapp from "../components/Whatsapp";
import Cosection from "../components/Cosections";

export const Payroll = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar />
      <div className="tax-page">
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">
              Payroll Processing Services
            </h1>
            <Link to="/services" className="tax-notification-body">
              ← Back to Services
            </Link>
          </div>
        </div>

        <div className="tax-content-container">
          <h1 className="tax-section-title">
            Efficient Payroll Processing and Maintenance at Litax.
          </h1>
          <p className="tax-section-description">
            Managing payroll is one of the most important — and challenging —
            aspects of running a business. From ensuring timely and accurate
            payments to staying compliant with tax regulations, payroll can
            quickly become overwhelming. At Litax., we provide end-to-end
            payroll solutions designed to simplify the process, save time, and
            minimize errors.
          </p>

          <h2 className="tax-subheading">
            Why Choose Litax. for Payroll Processing?
          </h2>
          <ul className="tax-section-description">
            <li>
              <strong>Expert Compliance:</strong> Payroll laws and tax
              requirements are constantly evolving. Our CPAs and EAs stay
              updated with the latest regulations to ensure your payroll remains
              fully compliant.
            </li>
            <li>
              <strong>Accuracy & Reliability:</strong> We leverage advanced
              payroll software and checks to ensure error-free calculations
              every time.
            </li>
            <li>
              <strong>Time-Saving:</strong> Outsourcing payroll frees up your
              resources, letting you focus on business growth rather than
              administrative tasks.
            </li>
            <li>
              <strong>Customized Solutions:</strong> Whether you have 5
              employees or 500, we tailor payroll services to match your
              workforce size and industry needs.
            </li>
            <li>
              <strong>Confidentiality:</strong> Payroll data is highly sensitive
              — we maintain strict data security standards to protect your
              business and employees.
            </li>
          </ul>

          <h2 className="tax-subheading">
            Our Payroll Processing and Maintenance Services
          </h2>
          <p className="tax-section-description">
            We provide a wide range of payroll services to keep your business
            running smoothly:
          </p>
          <ol className="tax-section-description">
            <li>
              <strong>Payroll Processing:</strong> Calculation of employee
              wages, deductions, overtime, and bonuses, with options for direct
              deposit or check payments.
            </li>
            <li>
              <strong>Tax Withholding & Reporting:</strong> Federal, state, and
              local tax calculations, quarterly filings (Form 941/940), and
              year-end compliance.
            </li>
            <li>
              <strong>Employee Benefits Management:</strong> Integration of
              deductions for health insurance, PF, retirement contributions, and
              other employee perks.
            </li>
            <li>
              <strong>Time & Attendance Tracking:</strong> Implementation of
              automated systems for accurate leave, overtime, and shift
              tracking.
            </li>
            <li>
              <strong>Year-End Reporting:</strong> Preparation of W-2s for
              employees and 1099s for contractors, ensuring smooth filing for
              everyone.
            </li>
            <li>
              <strong>Payroll Record Maintenance:</strong> Secure storage of all
              payroll histories, accessible when needed for audits or compliance
              checks.
            </li>
            <li>
              <strong>Multi-State Payroll:</strong> Handling payroll across
              multiple states with different tax laws and compliance
              requirements.
            </li>
            <li>
              <strong>Compliance Monitoring:</strong> Ongoing review to prevent
              penalties and fines from misclassification or missed filings.
            </li>
            <li>
              <strong>Payroll Consulting:</strong> Advisory on payroll
              structuring, employee classifications, and strategies to optimize
              tax efficiency.
            </li>
          </ol>

          <h2 className="tax-subheading">Advanced Payroll Features</h2>
          <p className="tax-section-description">
            Beyond the basics, we also offer additional services to support
            businesses with complex payroll needs:
          </p>
          <ul className="tax-section-description">
            <li>
              <strong>Integration with Accounting Software:</strong> Seamless
              syncing with QuickBooks, Xero, and other accounting platforms.
            </li>
            <li>
              <strong>Employee Self-Service Portals:</strong> Allow employees to
              access pay stubs, tax forms, and leave balances online.
            </li>
            <li>
              <strong>Customized Reports:</strong> Generate payroll analytics,
              cost breakdowns, and trend analysis for better financial
              decisions.
            </li>
            <li>
              <strong>International Payroll Assistance:</strong> Support for
              businesses with remote/global employees to handle cross-border
              payroll complexities.
            </li>
          </ul>

          <h2 className="tax-subheading">Get Started Today</h2>
          <p className="tax-section-description">
            At Litax., we are committed to making payroll processing
            stress-free and accurate. With our expert CPAs and EAs, advanced
            payroll tools, and compliance-focused approach, you can ensure
            smooth payroll operations every month. Contact us today to schedule
            a consultation and experience hassle-free payroll services tailored
            to your business needs.
          </p>
        </div>
      </div>

      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Payroll;
